
export const convertParametersSnapshotToMap = snapshot => {
    const transformedData = snapshot.docs.map(doc=>{
      return{
        id: doc.id,
        ...doc.data()
      };  
    })
    return transformedData;
  };